<h2 mat-dialog-title style="text-align: center">{{ title }}</h2>
<mat-dialog-content class="mat-typography" style="padding-bottom: 0.5rem;">
  <ng-container *ngIf="isAdmin">
    <div style="height: 40vh; flex: 1">
      <h2>Aussehen & Verhalten</h2>
      <div>
        <mat-list>
          <mat-list-item style="height: auto">
            <div
              class="row-layout flex-content-space-between settings-list-item"
            >
              <div style="flex: 1">SB Quittungen drucken</div>
              <div>
                <mat-radio-group
                  [value]="sbViewType"
                  (change)="onSbViewTypeChange($event)"
                >
                  <mat-radio-button class="setting-dialog-radio" [value]="1"
                    >als Dialog anzeigen</mat-radio-button
                  >
                  <mat-radio-button class="setting-dialog-radio" [value]="2"
                    >in Hauptbereich anzeigen</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isAdmin">
    <div *ngIf="screenIdx === 0">
      <button mat-button class="light-bg-color" (click)="openChangePassword()">
        Password ändern
      </button>
    </div>
    <div *ngIf="screenIdx === 1">
      <app-input
        label="Aktuelles Passwort"
        name="oldpassword"
        #oldpw
        [value]="passwords.oldpassword"
        (valueChange)="setPassword('oldpassword', $event)"
        [required]="true"
        type="password"
      ></app-input>
      <div style="height: 0.5rem"></div>
      <app-input
        label="Neues Passwort"
        name="newpassword"
        #newpw
        [value]="passwords.newpassword"
        (valueChange)="setPassword('newpassword', $event)"
        [required]="true"
        type="password"
      ></app-input>
      <div style="height: 0.5rem"></div>
      <app-input
        label="Neues Passwort wiederholen"
        name="newpassword_repeat"
        #newpwrepeat
        [value]="passwords.newpassword_repeat"
        (valueChange)="setPassword('newpassword_repeat', $event)"
        [required]="true"
        type="password"
      ></app-input>

      <div style="margin-top: 1rem">
        <span style="font-weight: 600">Passwortregeln</span>
        <ul>
          <li>Passwort muss mindestens 5 Zeichen lang sein.</li>
          <li>Passwort muss mindestens einen Buchstaben enthalten.</li>
          <li>Passwort muss mindestens eine Zahl enthalten.</li>
        </ul>
      </div>
      <div *ngIf="hasErrors" style="color: red">
        Fehler in den Eingaben erkannt.
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout flex-content-end pdf-dialog-actions"
  style="margin-top: 10px"
>
  <button mat-button class="document-cancel" (click)="close()">
    Abbrechen
  </button>
  <ng-container *ngIf="!isAdmin">
    <button
      *ngIf="screenIdx === 1"
      mat-button
      [disabled]="!canSave"
      class="document-save"
      (click)="savePassword()"
    >
      Speichern
    </button>
  </ng-container>
</div>
